import { connect } from 'react-redux';
import { selectors } from '../Stream';
import { flagEnabled } from '../redux/flags';
var mapStateToProps = function (state) { return ({
    biTotalItemsCount: selectors.getTotalItemsCount(state),
    smoothScroll: flagEnabled(state, 'smooth_scroll_to_top'),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=BackToTop.container.js.map